var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export default class PopupManager extends EventTarget {
    constructor(options = {}) {
        super();
        this.scrollTop = 0;
        this.scrollDisableCounter = 0;
        this.options = Object.assign(Object.assign({}, PopupManager.defaults()), options);
        this.init();
    }
    static defaults() {
        return {
            baseClass: 'popup',
            openTrigger: 'data-popup-open',
            closeTrigger: 'data-popup-close',
            closeOnBackdropClick: true,
            disableScroll: true,
            fixHeaderPadding: false,
        };
    }
    init() {
        document.addEventListener('keydown', this.handleDocumentKeydown.bind(this));
        document.addEventListener('click', this.handleDocumentClick.bind(this), true);
        this.element = null;
        this.dialog = null;
    }
    emit(eventName, options) {
        var _a;
        this.dispatchEvent(new CustomEvent(eventName, options));
        if (this.element) {
            (_a = this.element) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new CustomEvent(eventName, options));
        }
    }
    // public on(eventName: string, callback: (options?: CustomEventInit) => void) {
    //   this.addEventListener(eventName, (event: CustomEvent) => {
    //     callback(event.detail);
    //   });
    // }
    handleDocumentKeydown(event) {
        if ((event.code === 'Escape') && this.isOpen()) {
            void this.close();
        }
    }
    handleDocumentClick(event) {
        var _a, _b;
        const target = event.target;
        const trigger = target.closest(`[${this.options.openTrigger}]`);
        if (trigger) {
            event.preventDefault();
            const popupTarget = trigger.getAttribute((_b = (_a = this.options) === null || _a === void 0 ? void 0 : _a.openTrigger) !== null && _b !== void 0 ? _b : '') || trigger.getAttribute('href') || '';
            void this.open(popupTarget);
        }
        else if (target.closest(`[${this.options.closeTrigger}]`)) {
            event.preventDefault();
            void this.close();
        }
    }
    disableScrolling() {
        if (!this.options.disableScroll)
            return;
        const getScrollbarWidth = () => window.innerWidth - document.documentElement.clientWidth;
        const getBodyScrollTop = () => window.scrollY
            || (document.documentElement && document.documentElement.scrollTop)
            || (document.body && document.body.scrollTop);
        this.scrollDisableCounter += 1;
        document.documentElement.style.scrollBehavior = 'auto';
        this.scrollTop = document.body.dataset.scroll
            ? +document.body.dataset.scroll
            : getBodyScrollTop();
        document.body.dataset.scroll = String(this.scrollTop);
        if (getScrollbarWidth()) {
            // document.body.style.paddingRight = `${getScrollbarWidth()}px`;
            if (this.options.fixHeaderPadding) {
                const header = document.querySelector('.header__wrapper');
                if (header)
                    header.style.paddingRight = `${getScrollbarWidth()}px`;
            }
        }
        document.body.style.top = `-${this.scrollTop}px`;
        document.body.style.position = 'fixed';
        document.body.style.overflow = 'hidden';
        document.body.style.touchAction = 'none';
        document.body.classList.add('is-scroll-locked');
    }
    enableScrolling() {
        var _a;
        if (!this.options.disableScroll)
            return;
        this.scrollDisableCounter -= 1;
        if (this.scrollDisableCounter > 0)
            return;
        document.body.style.position = '';
        document.body.style.overflow = '';
        document.body.style.touchAction = '';
        document.body.style.paddingRight = '';
        document.body.style.top = '';
        if (this.options.fixHeaderPadding) {
            const header = document.querySelector('.header__wrapper');
            if (header)
                header.style.paddingRight = '';
        }
        document.body.classList.remove('is-scroll-locked');
        this.scrollTop = 0;
        const savedScrollTop = Number(((_a = document.body.dataset) === null || _a === void 0 ? void 0 : _a.scroll) || 0);
        if (savedScrollTop) {
            window.scrollTo(0, savedScrollTop);
        }
        document.body.removeAttribute('data-scroll');
        document.documentElement.style.scrollBehavior = '';
    }
    static getElementFromTarget(target) {
        if (typeof target === 'string') {
            return document.getElementById(target.replace('#', ''));
        }
        if (typeof target === 'object') {
            return target;
        }
        return null;
    }
    static hasAnimation(element) {
        const style = window.getComputedStyle(element);
        return style.animationName !== 'none' || style.transitionDuration !== '0s';
    }
    isOpen() {
        var _a;
        return Boolean((_a = this.element) === null || _a === void 0 ? void 0 : _a.classList.contains('is-open'));
    }
    open(target) {
        return __awaiter(this, void 0, void 0, function* () {
            const id = target.replace('#', '');
            if (!id) {
                console.warn('PopupManager: Invalid target ID provided');
                return;
            }
            if (this.isOpen()) {
                yield this.close();
                yield this.openDialog(id);
            }
            else {
                yield this.openDialog(id);
            }
        });
    }
    openDialog(id) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const doOpen = () => {
                if (this.element) {
                    this.element.classList.remove('is-opening');
                    this.element.classList.add('is-open');
                    this.emit('open');
                }
            };
            this.element = document.getElementById(id);
            this.dialog = (_a = this.element) === null || _a === void 0 ? void 0 : _a.querySelector(`.${this.options.baseClass}__dialog`);
            if (this.element && this.dialog) {
                this.emit('beforeOpen');
                (_b = this.element) === null || _b === void 0 ? void 0 : _b.classList.add('is-opening');
                this.disableScrolling();
                this.createBackdrop();
                yield new Promise((resolve) => {
                    var _a;
                    if (this.dialog && PopupManager.hasAnimation(this.dialog)) {
                        const onAnimationEnd = () => {
                            var _a;
                            (_a = this.dialog) === null || _a === void 0 ? void 0 : _a.removeEventListener('animationend', onAnimationEnd);
                            resolve();
                        };
                        (_a = this.dialog) === null || _a === void 0 ? void 0 : _a.addEventListener('animationend', onAnimationEnd);
                    }
                    else {
                        resolve();
                    }
                });
                doOpen();
            }
        });
    }
    close() {
        return __awaiter(this, void 0, void 0, function* () {
            const doClose = () => {
                if (this.element) {
                    this.element.classList.remove('is-closing');
                    this.element.classList.remove('is-open');
                    this.enableScrolling();
                    this.deleteBackdrop();
                    this.emit('close');
                    this.element = null;
                    this.dialog = null;
                }
            };
            this.emit('beforeClose');
            if (this.element && this.dialog) {
                this.element.classList.add('is-closing');
                if (PopupManager.hasAnimation(this.dialog)) {
                    yield new Promise((resolve) => {
                        var _a;
                        const onAnimationEnd = () => {
                            var _a;
                            (_a = this.dialog) === null || _a === void 0 ? void 0 : _a.removeEventListener('animationend', onAnimationEnd);
                            resolve();
                        };
                        (_a = this.dialog) === null || _a === void 0 ? void 0 : _a.addEventListener('animationend', onAnimationEnd);
                    });
                }
                doClose();
            }
        });
    }
    handleBackdropClick() {
        if (this.options.closeOnBackdropClick) {
            void this.close();
        }
    }
    createBackdrop() {
        if (!this.backdrop && this.element) {
            this.backdrop = document.createElement('div');
            this.backdrop.classList.add('popup__backdrop');
            this.element.prepend(this.backdrop);
            this.backdrop.addEventListener('click', this.handleBackdropClick.bind(this));
        }
    }
    deleteBackdrop() {
        if (this.backdrop) {
            const handleClick = this.handleBackdropClick.bind(this);
            this.backdrop.removeEventListener('click', handleClick);
            this.backdrop.remove();
            this.backdrop = null;
        }
    }
}
